import { CircleCheckBig, Shield, Vault } from 'lucide-react';

import { ICON_PROPS, PaymentPoint } from '../constants';

export const POINTS: PaymentPoint[] = [
  {
    icon: <CircleCheckBig {...ICON_PROPS} />,
    text: '{{companyName}} gets paid after you confirm the work is complete',
  },
  {
    icon: <Vault {...ICON_PROPS} />,
    text: ' Funds are securely held by a trusted third party',
  },
  {
    icon: <Shield {...ICON_PROPS} />,
    text: 'Full buyer protection',
  },
];
